import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';

export default Vue.component('dynamic-input-address', {
  template: require('./template.html'),
  name: 'dynamic-input-address',
  computed: {
    ...mapGetters(['currentSite']),
  },
  props: [
    'active-item',
    'type',
    'value',
    'inner-tabs',
    'dynamic-data',
    'dynamic-tab',
    'open-cropper',
    'input-errors',
  ],
  data() {
    return {
      hasErrors: false,
      display: {},
    };
  },
  watch: {
    innerTabs: {
      handler(tab) {
        if (tab[this.dynamicTab]) {
          this.setInitialValues();
        }
      },
      deep: true,
    },
    inputErrors(list) {
      this.hasErrors = list.find(item => item.key === this.type);
    },
  },
  methods: {
    setInitialValues() {
      if (!this.activeItem[this.type]) {
        const initial = _.cloneDeep(this.dynamicData.itemData[this.type].value);
        this.$store.dispatch('setDropletVal', {
          drp: this.activeItem,
          key: this.type,
          val: initial,
        });
      }
      this.$set(this.display, this.type, this.activeItem[this.type].value || '');
    },
    getInputVal(val) {
      return val.trim() !== '' ? val : false;
    },
    updateAddress() {
      this._debounce(async () => {
        this.$store.dispatch('setDropletVal', {
          drp: this.activeItem[this.type],
          key: 'value',
          val: this.getInputVal(this.display[this.type]),
        });
        const coords = await this.getCoords();
        if (coords) {
          this.$store.dispatch('setDropletVal', {
            drp: this.activeItem[this.type],
            key: 'lat',
            val: coords.lat(),
          });
          this.$store.dispatch('setDropletVal', {
            drp: this.activeItem[this.type],
            key: 'lng',
            val: coords.lng(),
          });
        }
      }, 250);
    },
    getCoords() {
      const geocoder = new google.maps.Geocoder(); // eslint-disable-line
      return new Promise((resolve) => {
        geocoder.geocode(
          {
            address: this.display[this.type],
          },
          (results, status) => {
            if (status === google.maps.GeocoderStatus.OK) {
              resolve(results[0].geometry.location);
            } else {
              resolve(false);
            }
          },
        );
      });
    },
    handleErrors() {
      if (this.value.required) {
        const value = this.display[this.type] || '';
        const input = value.replace(/\s/g, '');
        const hasError = this.value.required && input === '';
        this.$emit('set-input-error', { key: this.type, hasError, tab: this.dynamicTab });
        this.hasErrors = hasError;
      } else {
        this.hasErrors = false;
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/page/top-control-bar/dynamic-data/edit-item/inputs/address/index.js